var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13C17 13.3978 16.842 13.7794 16.5607 14.0607C16.2794 14.342 15.8978 14.5 15.5 14.5C15.1022 14.5 14.7206 14.342 14.4393 14.0607C14.158 13.7794 14 13.3978 14 13C14 12.6022 14.158 12.2206 14.4393 11.9393C14.7206 11.658 15.1022 11.5 15.5 11.5C15.8978 11.5 16.2794 11.658 16.5607 11.9393C16.842 12.2206 17 12.6022 17 13Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.813 5.72802L15.813 2.58502C16.1851 2.47867 16.5768 2.46016 16.9573 2.53094C17.3377 2.60172 17.6966 2.75986 18.0055 2.99291C18.3145 3.22596 18.5651 3.52755 18.7377 3.87393C18.9102 4.22031 19 4.60203 19 4.98902V6.00002C19.5304 6.00002 20.0391 6.21073 20.4142 6.5858C20.7893 6.96088 21 7.46958 21 8.00002V18C21 18.5304 20.7893 19.0392 20.4142 19.4142C20.0391 19.7893 19.5304 20 19 20H5C4.46957 20 3.96086 19.7893 3.58579 19.4142C3.21071 19.0392 3 18.5304 3 18V8.00002C3 6.95502 3.835 6.00702 4.813 5.72802ZM16.363 4.50802C16.4373 4.48684 16.5156 4.48318 16.5915 4.49733C16.6675 4.51148 16.7392 4.54305 16.8009 4.58956C16.8626 4.63607 16.9127 4.69626 16.9473 4.76539C16.9818 4.83453 16.9999 4.91073 17 4.98802V6.00002H11.14L16.363 4.50802ZM5 8.00002H19V18H5V8.00002Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/walletIcon.e2b5d2bde716f23a2b1cfda31a213319.svg";
export { ForwardRef as ReactComponent };